import type { SignInErrorCode } from '../lib/firebase';

/** Sign-in problems → the words each screen shows (locales/*.json). */
export const SIGN_IN_ERROR_KEYS: Record<SignInErrorCode, string> = {
  'wrong-code': 'code.wrongLast',
  'code-expired': 'code.expired',
  'too-many-requests': 'paused.text',
  'quota-exceeded': 'errors.signIn.quota',
  'invalid-number': 'errors.signIn.invalidNumber',
  blocked: 'errors.signIn.blocked',
  'not-allowed': 'errors.signIn.notAllowed',
  network: 'errors.signIn.network',
  unknown: 'errors.signIn.unknown',
};

/** The shared schemas' messages (in English, also sent by the API) → translated words. */
export const FIELD_MESSAGE_KEYS: Record<string, string> = {
  'Enter your name': 'profile.errors.nameEmpty',
  'Keep it under 80 characters': 'profile.errors.nameLong',
  'Use letters only': 'profile.errors.nameLetters',
  'Enter an email like name@example.com': 'profile.errors.email',
  'That email is too long': 'profile.errors.emailLong',
};

/** The element that holds the invisible reCAPTCHA on sign-in screens. */
export const RECAPTCHA_CONTAINER_ID = 'recaptcha-container';
